export default {
  title: 'Godziny otwarcia',
  headers: {
    edit_time: 'Edytuj godziny',
    create_time: 'Utwórz godziny',
  },
  labels: {
    select_all: 'Zaznacz wszystko',
    timezone: 'Strefa czasowa',
  },
  fields: {
    selected_days: {
      label: 'Wybrane dni',
    },
    opening_time: {
      label: 'Godzina otwarcia',
    },
    closing_time: {
      label: 'Godzina zamknięcia',
    },
  },
  columns: {
    days: 'Dni',
    time: 'Godzina',
  },
  buttons: {
    add_opening_time: 'Dodaj godzinę otwarcia',
    add: 'Dodaj',
    cancel: 'Anuluj',
    save: 'Zapisz',
    close: 'Zamknij',
    delete: 'Usuń',
    sync_from_online_shop: 'Synchronizuj ze sklepem online',
  },
  projects: {
    online_shop: 'Sklep online',
    reservations: 'Rezerwacje',
    storefront: 'Witryna',
    not_set_up: '{{project}} (nie skonfigurowano dla tej lokalizacji)',
  },
  feedback: {
    missing_info: 'Brakujące informacje',
  },
  toasts: {
    saving_success: 'Zapisano pomyślnie',
    saving_error: 'Nie udało się zapisać. Sprawdź informacje i spróbuj ponownie.',
    sync_success: 'Zsynchronizowano pomyślnie',
    sync_error: 'Nie udało się zsynchronizować godzin otwarcia ze sklepu online. Spróbuj ponownie.',
    hours_required: 'Godziny otwarcia są wymagane. Edytuj istniejące godziny',
    not_copied: {
      reservations: {
        not_set_up:
          'Rezerwacje nie zostały zaktualizowane: rezerwacje nie są jeszcze skonfigurowane dla tej lokalizacji. Zakładka Rezerwacje wyjaśnia dlaczego.',
        not_matched:
          'Rezerwacje nie zostały zaktualizowane: nie ma tam godzin otwarcia {{time}}. Sprawdź godziny w zakładce Rezerwacje.',
        failed:
          'Nie udało się zaktualizować rezerwacji. Użyj przycisku „Synchronizuj ze sklepem online” w zakładce Rezerwacje.',
      },
      storefront: {
        not_set_up: 'Witryna nie została zaktualizowana: nie znaleziono witryny dla tej lokalizacji.',
        not_matched:
          'Witryna nie została zaktualizowana: nie ma tam godzin otwarcia {{time}}. Sprawdź godziny w zakładce Witryna.',
        failed:
          'Nie udało się zaktualizować Witryny. Użyj przycisku „Synchronizuj ze sklepem online” w zakładce Witryna.',
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Strefa czasowa',
        },
      },
      toasts: {
        error: 'Nie udało się zaktualizować strefy czasowej',
      },
    },
  },
};
